import { getResolvedRef as e } from "@scalar/workspace-store/helpers/get-resolved-ref";
import { deSerializeParameter as t, getExample as n, getExampleFromSchema as r, isParamDisabled as i, serializeContentValue as a, serializeCookieStyle as o, serializeDeepObjectStyle as s, serializeFormStyle as c, serializeFormStyleForCookies as l, serializePipeDelimitedStyle as u, serializeSimpleStyle as d, serializeSpaceDelimitedStyle as f } from "@scalar/workspace-store/request-example";
import { isObjectLike as p } from "@scalar/helpers/object/is-object";
//#region src/code-example/helpers/operation-to-har/process-parameters.ts
var m = (t) => (t ?? []).map((t) => e(t)).filter((e) => e !== void 0), h = (e) => "allowReserved" in e && e.allowReserved !== void 0 ? e.allowReserved : "schema" in e && e.schema && typeof e.schema == "object" && "allowReserved" in e.schema ? e.schema.allowReserved === !0 : !1, g = (e, t) => h(t) ? e : encodeURIComponent(e), _ = (e) => {
	if (e.in === "header") return {
		style: "simple",
		explode: "explode" in e && e.explode !== void 0 && e.explode
	};
	if (e.in === "cookie") {
		let t = "explode" in e && e.explode !== void 0 ? e.explode : !0;
		return {
			style: "style" in e && e.style === "cookie" ? "cookie" : "form",
			explode: t
		};
	}
	let t = {
		path: "simple",
		query: "form",
		header: "simple",
		cookie: "form"
	}[e.in] ?? "form", n = "style" in e && e.style ? e.style : t;
	return {
		style: n,
		explode: "explode" in e && e.explode !== void 0 ? e.explode : n === "form"
	};
}, v = (a, o, s, c) => {
	let l = n(a, o, s);
	if (i(a, l, c)) return;
	if (l?.value !== void 0) return t(l.value, a);
	if (!("schema" in a) || !a.schema) return;
	let u = a.in === "path" ? { emptyString: `{${a.name}}` } : {}, d = e(a.schema);
	return d ? r(d, u) : void 0;
}, y = ({ harRequest: e, parameters: t, example: n, defaultDisabled: r }) => {
	let i = [...e.headers], p = [...e.queryString], h = [], y = e.url, x = m(t);
	for (let t of x) {
		if (!t.in || !t.name) continue;
		let m = v(t, n, void 0, r);
		if (m === void 0) continue;
		let { style: x, explode: S } = _(t);
		switch (t.in) {
			case "path":
				y = b(y, t, m, x, S);
				break;
			case "query":
			case "querystring":
				if ("content" in t && t.content) {
					let e = a(m, Object.keys(t.content)[0] ?? "application/json");
					p.push({
						name: t.name,
						value: g(e, t)
					});
					break;
				}
				switch (x) {
					case "form": {
						let e = c(m, S);
						if (Array.isArray(e)) for (let n of e) {
							let e = n.key || t.name;
							p.push({
								name: e,
								value: g(String(n.value), t)
							});
						}
						else p.push({
							name: t.name,
							value: g(String(e), t)
						});
						break;
					}
					case "spaceDelimited": {
						let e = f(m);
						p.push({
							name: t.name,
							value: g(e, t)
						});
						break;
					}
					case "pipeDelimited": {
						let e = u(m);
						p.push({
							name: t.name,
							value: g(e, t)
						});
						break;
					}
					case "deepObject":
						if (Array.isArray(m)) {
							let e = c(m, !0);
							if (Array.isArray(e)) for (let n of e) {
								let e = n.key || t.name;
								p.push({
									name: e,
									value: g(String(n.value), t)
								});
							}
							else p.push({
								name: t.name,
								value: g(String(e), t)
							});
						} else {
							let e = s(t.name, m);
							for (let n of e) p.push({
								name: n.key,
								value: g(n.value, t)
							});
						}
						break;
					default: p.push({
						name: t.name,
						value: g(String(m), t)
					});
				}
				break;
			case "header": {
				let e = d(m, S);
				i.push({
					name: t.name,
					value: String(e)
				});
				break;
			}
			case "cookie": {
				if (x === "cookie") {
					h.push(...o(t.name, m, S));
					break;
				}
				let n = l(m, S);
				if (Array.isArray(n)) for (let r of n) {
					let n = r.key || t.name, i = r.value === null ? "null" : String(r.value);
					e.cookies.push({
						name: n,
						value: i
					});
				}
				else {
					let r = n === null ? "null" : String(n);
					e.cookies.push({
						name: t.name,
						value: r
					});
				}
				break;
			}
		}
	}
	if (h.length) {
		let t = [...e.cookies.map((e) => `${encodeURIComponent(e.name)}=${encodeURIComponent(e.value)}`), ...h.map((e) => `${e.name}=${e.value}`)].join("; "), n = i.find((e) => e.name.toLowerCase() === "cookie");
		n ? i.splice(i.indexOf(n), 1, {
			...n,
			value: n.value ? `${n.value}; ${t}` : t
		}) : i.push({
			name: "Cookie",
			value: t
		});
	}
	return {
		url: y,
		headers: i,
		queryString: p,
		cookies: h.length ? [] : e.cookies,
		hasCookieStyleEntries: h.length > 0
	};
}, b = (e, t, n, r, i) => {
	switch (r) {
		case "matrix":
			if (i) {
				if (Array.isArray(n)) {
					let r = n.map((e) => `${t.name}=${e}`).join(";");
					return e.replace(`{;${t.name}}`, `;${r}`);
				}
				if (p(n)) {
					let r = Object.entries(n).map(([e, t]) => `${e}=${t}`).join(";");
					return e.replace(`{;${t.name}}`, `;${r}`);
				}
				return e.replace(`{;${t.name}}`, `;${t.name}=${n}`);
			}
			if (Array.isArray(n)) return e.replace(`{;${t.name}}`, `;${t.name}=${n.join(",")}`);
			if (p(n)) {
				let r = Object.entries(n).map(([e, t]) => `${e},${t}`).join(",");
				return e.replace(`{;${t.name}}`, `;${t.name}=${r}`);
			}
			return e.replace(`{;${t.name}}`, `;${t.name}=${n}`);
		case "label":
			if (i) {
				if (Array.isArray(n)) return e.replace(`{.${t.name}}`, `.${n.join(".")}`);
				if (p(n)) {
					let r = Object.entries(n).map(([e, t]) => `${e}=${t}`).join(".");
					return e.replace(`{.${t.name}}`, `.${r}`);
				}
				return e.replace(`{.${t.name}}`, `.${n}`);
			}
			if (Array.isArray(n)) return e.replace(`{.${t.name}}`, `.${n.join(",")}`);
			if (p(n)) {
				let r = Object.entries(n).map(([e, t]) => `${e},${t}`).join(",");
				return e.replace(`{.${t.name}}`, `.${r}`);
			}
			return e.replace(`{.${t.name}}`, `.${n}`);
		case "simple": {
			let r = d(n, i);
			return e.replace(`{${t.name}}`, String(r));
		}
		default: return e.replace(`{${t.name}}`, String(n));
	}
};
//#endregion
export { y as processParameters };

//# sourceMappingURL=process-parameters.js.map